// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"c899dfe5","453":"e5407da2"}[chunkId] + ".chunk.js";
};